import React from 'react';
import { BuildingOfficeIcon, CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';

/**
 * OrgBadge - displays the current organization context to the user.
 * Provides visual confirmation of which tenant's data is being viewed.
 */
const OrgBadge = ({ className = '' }) => {
  const { user } = useAuth();

  if (!user?.organization) return null;

  const orgName = user.organization_name || `Org #${user.organization}`;
  const plan = user.subscription_plan || user.plan;
  const status = user.subscription_status;

  const isActive = !status || status === 'active' || status === 'trial';

  return (
    <div
      className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border
        ${isActive
          ? 'bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 border-primary-200 dark:border-primary-700'
          : 'bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 border-amber-200 dark:border-amber-700'}
        ${className}`}
      title={`You are viewing data for: ${orgName}`}
      aria-label={`Organization: ${orgName}`}
    >
      <BuildingOfficeIcon className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
      <span className="truncate max-w-[120px]">{orgName}</span>
      {plan && (
        <span className="opacity-60 hidden sm:inline">· {plan}</span>
      )}
      {isActive ? (
        <CheckCircleIcon className="h-3.5 w-3.5 flex-shrink-0 text-green-500" aria-hidden="true" />
      ) : (
        <ExclamationCircleIcon className="h-3.5 w-3.5 flex-shrink-0 text-amber-500" aria-hidden="true" />
      )}
    </div>
  );
};

export default OrgBadge;
